import { PracticeGameScreen } from '@/screens/practice-game/PracticeGameScreen'

export default function () {
  return <PracticeGameScreen />
}
